// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"ActiveQuiz_ActiveQuiz__1OkcR","Question":"ActiveQuiz_Question__20bVi"};